export const SET_DATA = 'SET_DATA';
export const SET_ALL_ATTRIBUTES = 'SET_ALL_ATTRIBUTES';
export const SET_PRODUCT_TYPE = 'SET_PRODUCT_TYPE';
export const SET_USER_TYPE = 'SET_USER_TYPE';
export const CLEAR = 'CLEAR';

export const actionSetListingData = (payload: any) => ({
  type: SET_DATA,
  payload,
});

export const actionSetAllAttributes = (payload: any) => ({
  type: SET_ALL_ATTRIBUTES,
  payload,
});

export const actionSetProductType = (payload: any) => ({
  type: SET_PRODUCT_TYPE,
  payload,
});

export const actionSetUserType = (payload: any) => ({
  type: SET_USER_TYPE,
  payload,
});
